import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaBars  } from "react-icons/fa";
import "../home/MenuScreen.css"; 

const MenuButton: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState<boolean>(false);

  return (
    <div className="hamburger-container">
      <button
        className="hamburger-icon"
        onClick={() => setMenuOpen((prev) => !prev)}
        aria-label="Toggle menu"
      >
      <FaBars size={30} color="black" />
      </button>

      <div className={`dropdown-menu ${menuOpen ? 'open' : ''}`}>
        <Link to="/" className="menu-link" onClick={() => setMenuOpen(false)}>
          Home
        </Link>
        <Link to="/login" className="menu-link" onClick={() => setMenuOpen(false)}>
          Login
        </Link>
        <Link to="/shop" className="menu-link" onClick={() => setMenuOpen(false)}>
          Shop
        </Link>
        <a
          href="https://questgrid.com"
          className="menu-link"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => setMenuOpen(false)}
        >
          Questgrid®
        </a>
      </div>
    </div>
  );
};

export default MenuButton;
